import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SortDirectiveService {
  /**
   * The SortService is used for communication between instances of the SortDirective.
   * The notifyOther method informs other directives that they need to remove their sort icons.
   * In case of 2+ tables, we need their unique parent id to hide only those icons, which have the same parent.
   */
  private _notify = new Subject<string>();
  notify$ = this._notify.asObservable();

  public notifyOther(divId: string): void {
    this._notify.next(divId);
  }
}
